
@if (initialized) {
  <router-outlet></router-outlet>
} @else {
  <!-- //implement proper loading -->
  <div class="flex items-center justify-center h-screen">
    <div class="animate-spin rounded-full h-32 w-32 border-b-2 border-gray-900"></div>
  </div>
  <!-- <p>Loading configuration...</p> -->
}
